import * as React from "react";
import {observer} from "mobx-react";
import {Box, CircularProgress, MenuItem, TextField} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilledButton from "../../../components/buttons/FilledButton";

function AllowancesCreditNotesDownload({monthField, monthOptions, isDownloading, onDownload}) {
    const downloadIcon = isDownloading ? <CircularProgress size={16} color="inherit"/> : <FileDownloadIcon fontSize="small"/>;
    return (
        <Box display="flex" alignItems="center" gap={1}>
            <TextField select size="small" label="Mes a descargar" value={monthField.value}
                       onChange={(event) => monthField.updateValue(event.target.value)}
                       sx={(theme) => ({minWidth: 200, '& .MuiInputBase-root': {backgroundColor: theme.brand.field}})}>
                {monthOptions.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
            </TextField>
            <FilledButton disabled={isDownloading} onClick={onDownload} style={{whiteSpace: 'nowrap'}}>
                {downloadIcon}
                Descargar NCs
            </FilledButton>
        </Box>
    );
}

export default observer(AllowancesCreditNotesDownload);
